import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useContent } from "../lib/content";

const reveal = {
  hidden: { opacity: 0, y: 36 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Policies = () => {
  const { t } = useContent();

  const policies = [1, 2, 3, 4].map((n) => ({
    title: t(`policy_${n}_title`),
    text: t(`policy_${n}_text`),
  }));

  return (
    <section id="policies" className="py-20 sm:py-28 bg-white border-t border-black/[0.05]">
      <div className="max-w-6xl mx-auto px-6">
        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-editorial text-xl text-[#1c1a17]"
        >
          {t("policies_kicker")}
        </motion.p>
        <motion.h2
          variants={reveal}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-display font-extrabold tracking-[-0.02em] text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.1]"
        >
          {t("policies_heading")}
        </motion.h2>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {policies.map((p, i) => (
            <motion.div
              key={p.title}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className="card-soft p-6 relative overflow-hidden"
            >
              <span className="font-editorial text-5xl text-[#1c1a17]/15 absolute -top-1 right-4 select-none">
                0{i + 1}
              </span>
              <ShieldCheck size={18} className="text-[#1c1a17]" />
              <h3 className="font-display font-extrabold mt-4 tracking-tight">{p.title}</h3>
              <p className="text-sm text-neutral-500 mt-2 leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          variants={reveal}
          custom={2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          data-testid="terms-section"
          className="card-soft mt-12 p-8 sm:p-10"
        >
          <p className="text-[10px] font-bold tracking-[0.18em] uppercase text-[#1c1a17]">the fine print</p>
          <h3 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl mt-2">
            {t("terms_heading")}
          </h3>
          <div
            data-testid="terms-text"
            className="mt-6 text-sm text-neutral-500 leading-relaxed whitespace-pre-line max-w-3xl font-medium"
          >
            {t("terms_text")}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
